(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dp4y-delivery-badge-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  function parseClosedDates(value) {
    const dates = String(value || '').split(/[\s,;]+/).filter(Boolean);
    const valid = dates.every(date => /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date + 'T12:00:00Z')) && new Date(date + 'T12:00:00Z').toISOString().slice(0, 10) === date);
    return { valid, dates };
  }
  function dispatchLabel(epoch, timeTrusted, calendar) {
    if (!timeTrusted || !calendar.valid || !Number.isFinite(epoch)) return 'fast';
    try {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(epoch));
      const fields = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(fields.weekday);
      if (day < 0) return 'fast';
      const today = `${fields.year}-${fields.month}-${fields.day}`;
      let offset = 0;
      let label = 'today';
      if (day === 0) { offset = 1; label = 'monday'; }
      else if (day === 6) { offset = 2; label = 'monday'; }
      else if (Number(fields.hour) >= 15) { offset = day === 5 ? 3 : 1; label = day === 5 ? 'monday' : 'tomorrow'; }
      const target = new Date(Date.UTC(Number(fields.year), Number(fields.month) - 1, Number(fields.day) + offset, 12)).toISOString().slice(0, 10);
      if (calendar.dates.includes(today) || calendar.dates.includes(target)) return 'fast';
      return label;
    } catch (_) { return 'fast'; }
  }
  const configElement = document.getElementById('dp4y-delivery-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  const started = performance.now();
  const wallStart = Date.now();
  const renderedAt = Number(config.renderedAt) * 1000;
  const calendar = parseClosedDates(config.closedDates);
  const qa = config.themeId === 198901629262 && new URLSearchParams(location.search).get('dp4y_delivery_qa') === '1' ? document.getElementById('dp4y-delivery-qa') : null;
  let simulation = null;
  function update() {
    const elapsed = performance.now() - started;
    let epoch = Date.now();
    let trusted = Number.isFinite(renderedAt) && Math.abs(wallStart - renderedAt) < 120000 && Math.abs(epoch - wallStart - elapsed) < 2000;
    let activeCalendar = calendar;
    if (qa && simulation) {
      epoch = simulation.epoch + (simulation.running ? performance.now() - simulation.started : 0);
      trusted = simulation.trusted;
      if (simulation.exceptionalDay) activeCalendar = parseClosedDates('2026-10-05');
    }
    const key = dispatchLabel(epoch, trusted, activeCalendar);
    document.querySelectorAll('[data-dp4y-delivery-badge]').forEach(badge => {
      const label = badge.querySelector('[data-delivery-label]');
      const text = badge.dataset.deliveryException === 'true' ? config.fast : config[key];
      if (label && label.textContent !== text) label.textContent = text;
    });
    if (qa) {
      const status = qa.querySelector('[data-delivery-qa-status]');
      const text = JSON.stringify({ simulation: !!simulation, epoch, timeTrusted: trusted, calendarValid: activeCalendar.valid, closedDates: activeCalendar.dates, label: key });
      if (status.textContent !== text) status.textContent = text;
    }
  }
  if (qa) {
    qa.hidden = false;
    qa.addEventListener('click', event => {
      const button = event.target.closest('[data-delivery-qa-time]');
      if (!button) return;
      const value = button.dataset.deliveryQaTime;
      simulation = value === 'reset' ? null : {
        epoch: value === 'exception' ? Date.parse('2026-10-05T10:00:00+02:00') : Date.parse(value),
        running: button.hasAttribute('data-delivery-qa-running'), started: performance.now(),
        trusted: value !== 'uncertain', exceptionalDay: value === 'exception'
      };
      update();
    });
  }
  update();
  setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-dp4y-delivery-badge]') || node.querySelector('[data-dp4y-delivery-badge]'))))) update();
  }).observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
